import { render, staticRenderFns } from "./ActivityPopup.vue?vue&type=template&id=20c56c5d&scoped=true"
import script from "./ActivityPopup.vue?vue&type=script&lang=js"
export * from "./ActivityPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c56c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c56c5d')) {
      api.createRecord('20c56c5d', component.options)
    } else {
      api.reload('20c56c5d', component.options)
    }
    module.hot.accept("./ActivityPopup.vue?vue&type=template&id=20c56c5d&scoped=true", function () {
      api.rerender('20c56c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityPopup.vue"
export default component.exports